module.exports = __webpack_public_path__ + "static/media/JinRong2.3599a27a.png";